import { Fragment, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useTypedSelector } from "../../../../../store/store";

import styles from "./index.module.scss";

export const OptionalExtras = () => {
  const { t } = useTranslation();

  const reservation = useTypedSelector(
    (state) => state.reservation.reservation,
  );

  const groupedExtras = useMemo(() => {
    if (!reservation.sailings) {
      return [];
    }

    const extras = reservation.sailings.flatMap((sailing) =>
      sailing.cabins.flatMap((cabin) =>
        cabin.guests.flatMap((guest) =>
          guest.extras.map((extra) => ({
            ...extra,
            passengerName: `${guest.title} ${guest.given_name} ${guest.lastname}`,
          })),
        ),
      ),
    );

    const map = new Map();

    for (const extra of extras) {
      const existing = map.get(extra.code);

      if (!existing) {
        map.set(extra.code, { ...extra, passengers: [extra.passengerName] });
      } else {
        const passengers = existing.passengers;

        if (!passengers.includes(extra.passengerName)) {
          passengers.push(extra.passengerName);
        }
      }
    }

    return Array.from(map.values());
  }, [reservation.sailings]);

  if (!groupedExtras?.length) {
    return null;
  }

  return (
    <div className={styles.tableContainer}>
      <div>
        <h2 className={styles.tableContainer_title}>{t("optional extras")}</h2>
      </div>

      <div className={styles.tableWrapper}>
        <table>
          <thead>
            <tr>
              <th>{t("name")}</th>
              <th>{t("description")}</th>
              <th>{t("category")}</th>
            </tr>
          </thead>

          <tbody>
            {groupedExtras.map((extra) => {
              const { uuid, name, description, category } = extra;

              return (
                <Fragment key={uuid}>
                  <tr>
                    <td>
                      <p>{name}</p>
                    </td>
                    <td>
                      <p>{description}</p>
                    </td>
                    <td>
                      <p className={styles.category}>
                        {category.replaceAll("_", " ")}
                      </p>
                    </td>
                  </tr>

                  <tr className={styles.guestsRow}>
                    <td colSpan={3}>
                      <div className={styles.guests}>
                        {extra.passengers.map((passengername: string) => (
                          <div key={passengername} className={styles.guest}>
                            <p>{passengername}</p>
                          </div>
                        ))}
                      </div>
                    </td>
                  </tr>
                </Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
